export const themes = {
  default: {
    thRoot:
      'border-1 border-dashed border-gray-light flex items-center justify-center px-5 text-gray-light relative rounded',
    thNumber: 'absolute rtl:left-0 top-0 bottom-0 italic leading-one mx-5 text-15xl',
    thLabel: 'flex-1 font-bold text-center text-md text-gray-darker px-2',
    thRootFilled: 'relative shadow',
    thClear:
      'border-0 border-l-1 rtl:border-l-1 border-solid border-gray-light reset-button absolute leading-none overflow-hidden rtl:right-0 top-0 h-full w-1/10',
    thClearIconSize: '0.625rem',
  },
};
